<script>
    import load from '@/components/base/load';
    import BillQuery from '@/components/grid/viewgrid.vue';
    import BillHead from '@/components/form/formdetail.vue';
    import BillImport from '@/components/upload/billimport.vue';
    export default {
        mixins: [load],
        data () {
            return {
                globalConfig:{
                    dictKey:[],
                    dictData:{},
                    moduleMethod:[],
                    filterBtnFlag:true,
                    operflag:'I'
                },
                globalBillQueryList:{
                    showIndex:true,
                    multiSelect: false,
                    height:1,
                    defaultMethod:'search',
                    items:[]
                },
                globalBillHead:{
                    lineNum:'4',
                    labelWidth:100,
                    defaultMethod:'get',
                    importKey:'',
                    items:[]
                },
                billQueryControl:'BillQuery',
                billHeadControl:'BillHead',
                billImportControl:'BillImport',
                resources:'',
                methodPrefix:'',
                formDetailConfig:{},
                billImportConfig:{
                    typeData:[]
                },
                showHead:false,
                chooseImport:false,
                downtype:'',
                billQueryList:{},
                toolbar:{},
                billHead:{},
                billDetail:[],
                height:1,
                width:1
            };
        },
        components: {
            BillQuery,
            BillHead,
            BillImport
        },
        methods:{
            _initItem (items) {
                if (items && items.length > 0) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].dictkey) {
                            if (items[i].data === undefined) {
                                this.globalConfig.dictKey.push(items[i].dictkey);
                            }
                        }
                        if (items[i].valueChanged) {
                            items[i]['valueChanged'] = this[items[i]['valueChanged']];
                        }
                        if (items[i].searchBefore) {
                            items[i]['searchBefore'] = this[items[i]['searchBefore']];
                        }
                        if (items[i].setDataBefore) {
                            items[i]['setDataBefore'] = this[items[i]['setDataBefore']];
                        }
                    }
                }
            },
            initMethod(list) {
                Object.keys(list).forEach(pro => {
                    if (pro.startsWith('on')) {
                        if (this[list[pro]]) {
                            list[pro] =  this[list[pro]];
                        }
                    }
                });
            },
            initDict() {
                // 调用自定义方法
                if (this.initUserDict) {
                    this.initUserDict();
                }

                let index = 0;
                if (this.globalConfig.dictKey.length > 0) {
                    // 去除重复
                    this.globalConfig.dictKey = this.$Method.unique(this.globalConfig.dictKey);

                    // 去除自定义的字典
                    for (let temp in this.globalConfig.dictData) {
                        if (this.globalConfig.dictData[temp] && this.globalConfig.dictData[temp].length > 0) {
                            index = this.globalConfig.dictKey.findIndex(el => el === temp);
                            if (index > -1) {
                                this.globalConfig.dictKey.splice(index, 1);
                            }
                        }
                        
                    }
                    
                    // 调用字典方法
                    if (this.globalConfig.dictKey.length > 0) {
                        const dictKey = this.globalConfig.dictKey.join(',');
                        this.globalConfig.dictData = Object.assign({}, this.getDict(dictKey,'code,name,pro1,ddvalue'), this.globalConfig.dictData);
                    }
                  
                }
              
            },
            setDictData (obj) {
                if (obj) {
                    for (let temp in obj) {
                        this.globalConfig.dictData[temp] = obj[temp];
                    }
                }
            },
            getListConfig (name) {
                let list =  this.$Method.copy(this.formDetailConfig.list[name]);
                list.gridType = 'billGrid';
                list.showCondition = true;
                this.initMethod(list);
                return list;
            },
            getHeadConfig (name) {
                let list =  this.$Method.copy(this.formDetailConfig.head[name]);
                this.initMethod(list);
                return list;
            },
            getToolbarConfig (name) {
                let list =  this.$Method.copy(this.formDetailConfig.toolbar[name]);
                this.initMethod(list);
                return list;
            },
            getDetailConfig(name) {
                let list =  this.$Method.copy(this.formDetailConfig.detail[name]);
                this.initMethod(list);
                return list;
            },
            _actionMethod (action) {
                const _method = action.name;
                const  _methodBefore = _method + 'Before';
                const _methodAfter = _method + 'After';
                let flag = true;
                if (this[_method]) {
                    if (this[_methodBefore]) {
                        flag = this[_methodBefore](action);
                    }
                    if (flag) {
                        flag = this[_method](action);
                        if (flag && this[_methodAfter]){
                            this[_methodAfter]();
                        }
                    }
                }
            },
            _getIndexAction(action) {
                return this.billHead.toolbar.items.findIndex(item => item.name === action.name);
            },
            _getActionName(action) {
                let name = '';
                const index = this._getIndexAction(action);
                if (index > -1) {
                    name = this.billHead.toolbar.items[index].text;
                }
                if (this.getActionName) {
                    name = this.getActionName(action);
                }
                return name;
            },

            _getActionMethod(action) {
                let name = action.name;
                const type = action.name;
                switch(type) {
                    case 'saveData':
                        name = 'save';
                        break;
                    case 'delData':
                        name = 'delete';
                        break;
                    case 'billImport':
                        name = 'importexcel';
                        break;
                }
                if (this.getActionMethod) {
                    const temp = this.getActionMethod(action);
                    if(temp) {
                        name = temp;
                    }
                }
                return name;
            },
            doPost(action,baseUrl,method,postData,SuccessFun) {
                let flag = true;
                let self = this;
                this.loadingtext = self._getActionName(action);
                this.showLoading();
                self.synchroPost(baseUrl, method, postData, function(data){
                    SuccessFun(data);
                    const msg = self._getActionName(action) +'成功!';
                    self.hideLoading();
                    self.alert(msg,null,3);
                },function(data) {
                    const msg = self._getActionName(action) +'失败!' + data;
                    self.hideLoading();
                    self.alert(msg,null,2);
                    flag = false;
                },function(data) {
                    const msg = self._getActionName(action) +'异常!' + data;
                    self.hideLoading();
                    self.alert(msg,null,2);
                    flag = false;
                });
                return flag;
            },
            refurbish (para) {
                let self = this;
                this.loadingtext = '加载';
                this.showLoading();
                self.synchroPost(self.billHead.resources, self.billHead.method , para, self._setBillData);
            },

            _setBillData(data){
                this.$refs.head.changedStatus('S');
                if (this.setBillData) {
                    data = this.setBillData(data);
                }
                this.$refs.head.setData(data[this.billHead.name]);
                this.$refs.head.setFormReadOnly(true);
                this.globalConfig.operflag = 'V';  
                this.hideLoading();
            },
            saveDataSuccess(data) {
                this.refurbish(data[0]);
            },

            delDataSuccess() {
                this.$refs.head.clearData();
                this.$refs.head.changedStatus('D');
                this.$refs.head.setFormReadOnly(true);
            },

            addData() {
                if (this.globalConfig.operflag === 'U') {
                    if (this.$refs.head.isChange()) {
                        let self = this;
                        self.$Modal.confirm({
                            title: '确认',
                            content: '单据有修改未保存，是否放弃修改？',
                            onOk: () => {
                                self.addDataCommon();
                            }
                        });
                    }
                } else {
                    this.addDataCommon();
                }
                return true;
            },
            addDataCommon() {
                this.$refs.head.clearData();
                this.showHead = true;
                this.globalConfig.operflag='I';
                this.$refs.head.setFormReadOnly(false);
                this.$refs.head.changedStatus('N');
            },
            editData() {
                this.globalConfig.operflag ='U';
                this.$refs.head.setFormReadOnly(false);
                this.$refs.head.changedStatus('E');
                return true;
            },

            delData(action) {
                let self = this;
                let flag = true;
                self.$Modal.confirm({
                    title: '确认',
                    content: '确定是否删除单据？',
                    onOk: () => {
                        let method = self.methodPrefix + '.' + self._getActionMethod(action);
                        let form = self.$refs.head.getData();
                        form.flag = 'D';
                        if (self.getCustomChangeData) {
                            form = self.getCustomChangeData(form);
                        }
                        self.globalConfig.operflag='';
                        flag = self.doPost(action,self.billHead.resources,method,form,self.delDataSuccess);
                    
                    }
                });
                return flag;
            },
            
            saveData(action) {
                let method = this.methodPrefix + '.' + this._getActionMethod(action);
                this.$refs.head.checkValidate();
                if (this.$refs.head.isError()) {
                    return;
                }
                let form = this.$refs.head.getChangeData();
                form.flag = this.globalConfig.operflag;
                if (this.getCustomChangeData) {
                    form = this.getCustomChangeData(form);
                }
                return this.doPost(action,this.billHead.resources,method,form,this.saveDataSuccess);
            },
           
            billImport(action) {
                const url = this.resources;
                const method =  this.methodPrefix + '.' + this._getActionMethod(action);
                let para = this.getImportParam();
                this.$refs.billImport.setModeltype('upload');
                this.$refs.billImport.setUrl(url,method,para);
                this.$refs.billImport.setShowUpload(true);
            },
            downTemplate() {
                const url = this.resources;
                this.$refs.billImport.setModeltype('down');
                let param = this.getImportParam();
                this.$refs.billImport.setDownUrl(url,param);
            },
            getImportParam(){
                let para = {};
                para.billmoduleid =  this._getImportModule();
                para.billno =  this.$refs.head.getValue(this.billHead.importKey);
                return para;
            },
            _getImportModule() {
                if (this.getImportModule) {
                    return this.getImportModule();
                } else {
                    return this.modulecode;
                }
            },
            importSuccess() {
                let para={};
                para[this.$refs.list.myConfig.bindSearchParam]=  this.$refs.head.getValue(this.$refs.list.myConfig.bindSearchParam);
                this.refurbish(para);
            },
            initBillQueryList() {
                for (let global in this.globalBillQueryList) {
                    if (this.billQueryList[global] === undefined) {
                        this.billQueryList[global] = this.globalBillQueryList[global];
                    }
                }
                
                let listConfig  = this.getListConfig(this.billQueryList.name);
                for (let tempList in listConfig) {
                    this.billQueryList[tempList] = listConfig[tempList];
                }

                if (this.billQueryList.method === undefined) {
                    this.billQueryList.method = this.methodPrefix + '.' + this.billQueryList.defaultMethod;

                }

                if (this.billQueryList.resources === undefined) {
                    this.billQueryList.resources = this.resources; 
                } else {
                    this.billQueryList.resources = this.OmdUrl[this.billQueryList.resources];
                }

                if (this.billQueryList.response === undefined) {
                    this.billQueryList.response = this.billQueryList.name;
                }
                this._initItem(this.billQueryList.items);
                if (this.customInitBillQueryList) {
                    this.customInitBillQueryList();
                }
                this.billQueryList.height = 1;
                this.billQueryList.adjustHeight = 5;
            },
            initBillHead() {
                for (let global in this.globalBillHead) {
                    if (this.billHead[global] === undefined) {
                        this.billHead[global] = this.globalBillHead[global];
                    }
                }

                let headConfig  = this.getHeadConfig(this.billHead.name);
                for (let tempList in headConfig) {
                    this.billHead[tempList] = headConfig[tempList];
                }

                if (this.billHead.method === undefined) {
                    this.billHead.method = this.methodPrefix + '.' + this.billHead.defaultMethod;

                }

                if (this.billHead.resources === undefined) {
                    this.billHead.resources = this.resources; 
                } else {
                    this.billHead.resources = this.OmdUrl[this.billHead.resources];
                }

                if (this.billHead.response === undefined) {
                    this.billHead.response = this.billHead.name;
                }

                if (this.billDetail.length > 0) {
                    this.billHead.detail = [];
                    for (let detail = 0; detail < this.billDetail.length; detail++){
                        this.initBillDetail(this.billDetail[detail]);
                    }
                }
                this._initItem(this.billHead.items);
                this.initToolbar(this.toolbar);
                if (this.customInitBillHead) {
                    this.customInitBillHead();
                }
            },
            initBillDetail(obj) {
                let detailConfig  = this.getDetailConfig(obj.name);
                let type ={};
                type.code = this.billImportConfig.typeData.length + 1;
                type.name = detailConfig.title;
                this.billImportConfig.typeData.push(type);
                this._initItem(detailConfig.items);
                if (detailConfig.cellbeginedit) {
                    detailConfig.cellbeginedit = this[detailConfig.cellbeginedit];
                }
                this.billHead.detail.push(detailConfig); 
            },
            initToolbar(obj) {
                this.billHead.toolbar = this.getToolbarConfig(obj.name);
            },
            dbclick(e) {
                let para={};
                para[this.$refs.list.myConfig.bindSearchParam]=e[this.$refs.list.myConfig.bindSearchParam];
                this.showHead = true;
                this.refurbish(para);
                this.$refs.head.gridChangedStatus(this.billHead.toolStatus, e[this.billHead.toolStatus]);
            },
            back() {
                if (this.globalConfig.operflag !== 'V') {
                    if (this.$refs.head.isChange()) {
                        let self = this;
                        self.$Modal.confirm({
                            title: '确认',
                            content: '单据有修改未保存，是否放弃修改？',
                            onOk: () => {
                                this.doBack();
                            }
                        });
                    } else {
                        this.doBack();
                    }
                } else {
                    this.doBack();
                }
            },
            doBack() {
                this.showHead = false;
                this.$refs.list.refurbish();
            },
            doFirstSteps() {
                let self = this;
                //self.showLoading();
                self.$nextTick(() => {
                    setTimeout(() => {
                        self.$refs.list.refurbish();
                        //self.hideLoading();
                    }, 100);
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/layout/layoutbase.vue